import { Injectable, Injector } from '@angular/core';
// import { NgxIndexedDBService } from 'ngx-indexed-db';
import Dexie, { Table, liveQuery } from 'dexie';
import { AppSettings } from '../app.settings';
import { EncryptionService } from './encryption.service';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';
//IdbService

export const CURRENT_STORAGE_FORMAT: string = 'arraybuffer';


export function getDbName(): string {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const subdomain = parts.length >= 3 ? parts[0] : 'root';
  return `DigitalEyesDb_${subdomain}`;
}
export interface AddressFileRecord {
  id: any;
  taskId: string;
  FileName: string;
  FileType: string;
  FileSize: number;
  UploadStatus: string;
  RetryHitting: number;
  MetaData?: string;
  ServerFileID: number;
  ServerFileName: string;
  LiveUrl: string;
  zoneDetails?: any;
  base64image: string;
}
class DigitalEyesDb extends Dexie {

  public AddressPhotoFilesDetails: Dexie.Table;
  public InspectionFilesDetails: Dexie.Table; // id is number in this case
  public MetaFileDetails: Dexie.Table;
  public ChecklistDetail: Dexie.Table;
  public TaskChecklistDetail: Dexie.Table;
  public TaskTemplateDetails: Dexie.Table;
  public privateDetectTable: Dexie.Table;
  public fnolDataTable: Dexie.Table;
  public orgMasterDataTable: Dexie.Table;
  public AppSettings!: Dexie.Table<any, string>;
  public: Dexie.Table;
  public constructor() {
    super(getDbName());
    try {
      this.version(1).stores({
        InspectionFilesDetails: "++InspectionFileId,taskId, fileName, filePath",
        AddressPhotoFilesDetails: "++AddressFileId,taskId,FileName,FileType,FileSize,UploadStatus,RetryHitting,MetaData,ServerFileID,ServerFileName,LiveUrl,zoneDetails,base64image",
        MetaFileDetails: "++MetaFileId,TaskID,UserID,FileName,uploadStatus,base64image,downloadStatus",
        ChecklistDetail: "++CheckListId,TaskID,UserID,controlType,controlName,controlvalue,templateName,templateId,isUploadedOnServer",
        TaskChecklistDetail: "++TaskCheckListId,TaskID,UserID,controlType,controlName,controlvalue,isUploadedOnServer",
        TaskTemplateDetails: '++TaskTempId, taskId, templateId, userId',
        fnolDataTable: '++fnolId, taskId',
        privateDetectTable: "++Id,blobData",
        orgMasterDataTable: "++Id, orgTemplateData, taskId",
        AppSettings: 'key',
        AddressHistoryDetails: "id,taskId,inspectionId,captureDate,isskip,downloadStatus"
      });
      this.AddressPhotoFilesDetails = this.table("AddressPhotoFilesDetails");
      this.InspectionFilesDetails = this.table("InspectionFilesDetails");
      this.MetaFileDetails = this.table("MetaFileDetails");
      this.ChecklistDetail = this.table("ChecklistDetail");
      this.TaskChecklistDetail = this.table("TaskChecklistDetail");
      this.TaskTemplateDetails = this.table("TaskTemplateDetails");
      this.fnolDataTable = this.table("fnolDataTable");
      this.privateDetectTable = this.table("privateDetectTable");
      this.orgMasterDataTable = this.table("orgMasterDataTable");
    } catch (error) {

    }
  }
}

@Injectable({
  providedIn: 'root'
})

export class IdbService {
  db: any;
  idbservice: any;
  componentName: string = 'idbService';

  constructor(public _appsettings: AppSettings,
    public encryptionService: EncryptionService,
    private injector: Injector
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }
  async addressVerificationFilesDetails(obj: any): Promise<string> {
    try {
      const db = new DigitalEyesDb(); // ensure Dexie instance
      const id = await db.AddressPhotoFilesDetails.add(obj);
      return id;
    } catch (error) {
      console.error('Error saving file to IndexedDB:', error);
      throw error;
    }
  }

  async deleteAddressVerificationFile(fileName: string): Promise<void> {
    try {
      const db = new DigitalEyesDb();
      const count = await db.AddressPhotoFilesDetails
        .where('FileName')
        .equals(fileName)
        .delete();
      if (count === 0) {
        console.warn('No IDB record found to delete for FileName:', fileName);
      }
    } catch (error) {
      console.error('Error deleting file from IndexedDB:', error);
      throw error;
    }
  }



  async addInspectionFilesDetails(obj) {
    this.db = new DigitalEyesDb();
    const id = await this.db.InspectionFilesDetails.add(obj);
    return id;
  }

  async clearTableAddressVerificationImage(taskId) {
    this.db = new DigitalEyesDb();
    await this.db.AddressPhotoFilesDetails.clear();
  }
  // Dumm upload
  async getAddressTaskFileDetails(taskId = null) {
    this.db = new DigitalEyesDb();
    return await this.db.AddressPhotoFilesDetails.where("taskId").equals(taskId).and(item => item.UploadStatus == 'false').toArray();
  }

  async deletePendingFiles(files: any[]) {
    const db = new DigitalEyesDb();
    for (const file of files) {
      await db.AddressPhotoFilesDetails
        .where('FileName')
        .equals(file.FileName)
        .delete();
    }
  }


  // async getUnsyncFilesWithMaxRetry(taskId, maxHitCounter) {
  //   this.db = new DigitalEyesDb();
  //   return await this.db.InspectionFilesDetails.where("taskId").equals(taskId).and(item => item.RetryHitting >= maxHitCounter && item.UploadStatus == 'false').toArray();
  // }

  async updateHitCount(InspectionFile, hitCount) {
    this.db = new DigitalEyesDb();
    await this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { RetryHitting: hitCount });
  }

  async updateFileDetails(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? 'true' : 'false';
    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { UploadStatus: uploadStatus, ServerFileName: uploadFileDetails.Data[0].serverFileName }).then(function (updated) {
      if (updated) {
        return true;
      }
      else {
        return false;
      }
    });
  }

  async updateMetaFileDetails(metaFileDetail: any, updateStatus: boolean): Promise<boolean> {
    try {
      const db = new DigitalEyesDb();

      const updated = await db.MetaFileDetails
        .where('FileName')
        .equals(this.encryptionService.encrypt(metaFileDetail.fileName))
        .modify({ uploadStatus: updateStatus });
      return updated > 0;
    } catch (err: any) {
      return false;
    }
  }


  fileStatusChange(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    var uploadStatus = uploadFileDetails;
    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, { UploadStatus: uploadStatus }).then(function (updated) {
      if (updated) {
        return true;
      }
      else {
        return false;
      }
    });
  }

  async updateAddressFileDetails(InspectionFile: any, uploadFileDetails: any) {
    this.db = new DigitalEyesDb();
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? 'true' : 'false';
    await this.db.AddressPhotoFilesDetails.update(InspectionFile.AddressFileId, { UploadStatus: uploadStatus, ServerFileName: uploadFileDetails.Data[0].fileName }).then(function (updated: any) {

    });
  }

  async updateAddressFileDetailsErrorCase(InspectionFile: any, status: any) {
    await this.db.AddressPhotoFilesDetails.update(InspectionFile.AddressFileId, { UploadStatus: status }).then(function (updated: any) {
    });
  }

  async insertdummyblob(obj) {
    this.db = new DigitalEyesDb();
    var ids = await this.db.privateDetectTable.add(obj).then(function (res) {
      return res;
    }, err => {
      return 'private window'
    });
    return ids;
  }


  async deleteTaskFilesFromLocal(taskId, orgId) {
    this.db = new DigitalEyesDb();
    await this.db.InspectionFilesDetails.filter(item => item.taskId == taskId && item.orgid == orgId).delete();
    await this.db.MetaFileDetails.filter(item => item.TaskID == taskId && item.orgid == orgId).delete();
    await this.db.ChecklistDetail.filter(item => item.TaskID == taskId).delete()
    await this.db.TaskTemplateDetails.filter(item => item.taskId == taskId).delete()
  }
  async addInspectionFilesDetailsBulk(objects: any): Promise<void> {
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }

    try {
      await this.db.InspectionFilesDetails.bulkPut(objects); // insert or update
    } catch (error) {
      console.error('Bulk insert failed:', error);
      throw error;
    }
  }


  async deleteImageByFileName(fileName: string, taskId: string, orgId: string) {

    try {

      if (!this.db) {
        this.db = new DigitalEyesDb();
      }

      // Encrypt all fileNames before query
      // const encryptedFileName = this.encryptionService.encrypt(fileName);

      await this.db.InspectionFilesDetails
        .where('taskId')
        .equals(taskId)
        .and(item => item.orgid == orgId && item.fileName == fileName)
        .delete();

      return { Status: true };

    } catch (error) {

      console.error("Bulk delete error:", error);
      return { Status: false };
    }
  }

  async deleteMetaDataByFileName(fileName: string, taskId: string, orgId: string, status: any): Promise<void> {
    try {

      if (!this.db) {
        this.db = new DigitalEyesDb();
      }

      const encryptedFileName = this.encryptionService.encrypt(fileName);
      await this.db.MetaFileDetails
        .where('TaskID')
        .equals(taskId)
        .filter(item => item.orgid == orgId && item.FileName == encryptedFileName)
        .delete();
    } catch (error) {
      console.error('Error deleting file metadata from IndexedDB:', error);
    }
  }

  async deleteMetaDataByFileNames(fileNames: string[], taskId: string, orgId: string, status: any): Promise<void> {
    try {
      if (!this.db) {
        this.db = new DigitalEyesDb();
      }

      // Encrypt all fileNames at once
      const encryptedFileNames = fileNames.map(
        (fileName: string) => this.encryptionService.encrypt(fileName)
      );

      await this.db.MetaFileDetails
        .where('TaskID')
        .equals(taskId)
        .filter(
          (item: any) => item.orgid == orgId &&
            encryptedFileNames.includes(item.FileName)
        )
        .delete();

    } catch (error) {
      console.error('Error deleting file metadata from IndexedDB:', error);
    }
  }

  async updateMetaDeta(
    taskId: string,
    fileName: string,
    controlid: string,
    metaTags: string,
    observationText: string,
    zoneName: string,
    photoCategory: string,
    AiCheck: string,
    orgId: any
  ): Promise<void> {
    try {
      if (!this.db) {
        this.db = new DigitalEyesDb(); // or your custom DB instance
      }

      const encryptedFileName = this.encryptionService.encrypt(fileName);
      const encryptedObservationText = this.encryptionService.encrypt(observationText);

      await this.db.MetaFileDetails
        .where('TaskID')
        .equals(taskId)
        .filter(item => item.orgid == orgId && item.FileName === encryptedFileName)
        // .filter(item => item.orgid == orgId && item.fileName === encryptedFileName)
        .modify({
          controlId: controlid,
          uploadStatus: 'false',
          metaData: metaTags,
          observationText: encryptedObservationText,
          zoneName: zoneName,
          photoCategory: photoCategory,
          AICheck: AiCheck
        });

    } catch (error) {
      console.error('Error updating metadata in IndexedDB:', error);
    }
  }




  // In app-services or a dedicated service
  async addInspectionMetaFilesDetailsBulk(objects: any): Promise<void> {
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }

    try {
      await this.db.MetaFileDetails.bulkPut(objects); // insert or update
    } catch (error) {
      console.error('Bulk insert failed:', error);
      throw error;
    }
  }

  async addInspectionMetaFilesDetails(obj) {
    this.db = new DigitalEyesDb();
    const id = await this.db.MetaFileDetails.add(obj);
    return id;
  }


  // idb-service.ts
  async saveChecklistQues(
    zoneChecklistData,
    templateId,
    templateName,
    TaskId,
    UserId,
    status,
    checklistControlValue
  ): Promise<void> {
    const db = new DigitalEyesDb();

    if (zoneChecklistData.controlType === 'checkbox') {
      // Optional: you can implement saveChecklistCheckboxControlQues as needed
      await this.saveChecklistCheckboxControlQues(
        zoneChecklistData,
        templateId,
        templateName,
        TaskId,
        UserId,
        status
      );
    } else {
      const controlValue =
        zoneChecklistData.controlType === 'table'
          ? JSON.stringify(zoneChecklistData.controlvalue)
          : zoneChecklistData.controlvalue;

      const data = {
        TaskID: TaskId,
        UserID: UserId,
        controlType: zoneChecklistData.controlType,
        controlName: zoneChecklistData.controlName,
        // mapControlName: zoneChecklistData.mapControlName,
        controlvalue: controlValue,
        templateName: templateName,
        templateId: templateId,
        isUploadedOnServer: status
      };

      try {
        await db.ChecklistDetail.add(data);
      } catch (error) {
        console.error('Checklist insert failed', error);
      }
    }
  }

  async saveChecklistThirdPatryCheckboxControlQues(
    zoneChecklistData: any,
    templateId: any,
    TaskId: any,
    UserId: any,
    status: boolean
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    if (zoneChecklistData.controlType === 'checkbox') {
      // Optional: you can implement saveChecklistCheckboxControlQues as needed
      await this.saveChecklistCheckboxThirdPatryControlQues(
        zoneChecklistData,
        templateId,
        TaskId,
        UserId,
        status
      );
    } else {
      const controlValue =
        zoneChecklistData.controlType === 'table'
          ? JSON.stringify(zoneChecklistData.controlvalue)
          : zoneChecklistData.controlvalue;

      const data = {
        TaskID: TaskId,
        UserID: UserId,
        controlType: zoneChecklistData.controlType,
        controlName: zoneChecklistData.controlName,
        controlvalue: controlValue,
        templateId: templateId,
        isEnable: zoneChecklistData.isEnable,
        isUploadedOnServer: status
      };

      try {
        const id = await db.ChecklistDetail.add(data);
        return { Status: true, data: id };
      } catch (error) {
        console.error('Dexie insert failed for checkbox control:', error);
        return { Status: false, data: error };
      }
    }
  }




  // idb-service.ts
  async deleteChecklistDetail(TaskId: any): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    try {
      // Get all matching records first
      const recordsToDelete = await db.ChecklistDetail
        .where('TaskID')
        .equals(TaskId)
        .primaryKeys(); // get IDs to delete

      // Bulk delete by primary keys
      await db.ChecklistDetail.bulkDelete(recordsToDelete);

      return { Status: true, data: `${recordsToDelete.length} record(s) deleted` };
    } catch (error) {
      console.error('Dexie deleteChecklistDetail failed:', error);
      return { Status: false, data: JSON.stringify(error) };
    }
  }


  // idb-service.ts
  async saveChecklistCheckboxControlQues(
    zoneChecklistData: any,
    templateId: any,
    templateName: any,
    TaskId: any,
    UserId: any,
    status: boolean
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    const data = {
      TaskID: TaskId,
      UserID: UserId,
      controlType: zoneChecklistData.controlType,
      controlName: zoneChecklistData.controlName,
      controlvalue: JSON.stringify(zoneChecklistData.controlvalue), // checkbox values as JSON string
      // mapControlName: zoneChecklistData.mapControlName,
      templateName: templateName,
      templateId: templateId,
      isUploadedOnServer: status
    };

    try {
      const id = await db.ChecklistDetail.add(data);
      return { Status: true, data: id };
    } catch (error) {
      console.error('Dexie insert failed for checkbox control:', error);
      return { Status: false, data: error };
    }
  }

  async saveChecklistCheckboxThirdPatryControlQues(
    zoneChecklistData: any,
    templateId: any,
    TaskId: any,
    UserId: any,
    status: boolean
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    const data = {
      TaskID: TaskId,
      UserID: UserId,
      controlType: zoneChecklistData.controlType,
      controlName: zoneChecklistData.controlName,
      controlvalue: JSON.stringify(zoneChecklistData.controlvalue), // checkbox values as JSON string
      templateId: templateId,
      isUploadedOnServer: status
    };

    try {
      const id = await db.ChecklistDetail.add(data);
      return { Status: true, data: id };
    } catch (error) {
      console.error('Dexie insert failed for checkbox control:', error);
      return { Status: false, data: error };
    }
  }


  // idb-service.ts
  async getChecklistFromLocalDbByControlName(
    TaskId: any,
    controlName: any,
    templateId: any
  ): Promise<{ status: boolean; data: any[] }> {
    const db = new DigitalEyesDb();

    try {
      // Query using compound conditions
      const results = await db.ChecklistDetail
        .where('TaskID')
        .equals(TaskId)
        .filter((row: any) =>
          row.controlName === controlName && row.templateId === templateId
        )
        .toArray();

      const items = results.map(row => ({
        CheckListId: row.id, // assuming '++id' is used in Dexie schema
        TaskID: row.TaskID,
        controlName: row.controlName,
        controlType: row.controlType,
        controlvalue: row.controlvalue,
        templateName: row.templateName,
        templateId: row.templateId,
        isUploadedOnServer: row.isUploadedOnServer
      }));

      return { status: items.length > 0, data: items };
    } catch (err) {
      console.error('Dexie query failed:', err);
      return { status: false, data: [] };
    }
  }


  // idb-service.ts
  async updateChecklistTable(
    TaskId: any,
    controlType: any, // optional: not used in update condition
    controlName: any,
    controlvalue: any,
    templateName: any, // optional: not used in update
    templateId: any,
    isUploadedOnServer: string = 'false'
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    try {
      const controlValue = Array.isArray(controlvalue)
        ? JSON.stringify(controlvalue)
        : controlvalue;

      // Find the matching record(s)
      const records = await db.ChecklistDetail
        .where('TaskID')
        .equals(TaskId)
        .filter((row: any) =>
          row.templateId === templateId && row.controlName === controlName
        )
        .toArray();

      if (records.length === 0) {
        return { Status: false, data: 'No matching record found' };
      }

      // Update each matching record
      const updates = records.map(async (record) => {
        return db.ChecklistDetail.update(record.CheckListId, {
          controlvalue: controlValue,
          isUploadedOnServer: isUploadedOnServer
        });
      });

      await Promise.all(updates);

      return { Status: true, data: records.length + ' record(s) updated' };
    } catch (error) {
      console.error('Dexie update failed:', error);
      return { Status: false, data: error };
    }
  }

  async updateChecklistEnableControl(
    TaskId: any,
    isEnable: any, // optional: not used in update condition
    controlName: any,
    templateId: any,
    controlvalue?: any
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    try {

      // Find the matching record(s)
      const records = await db.ChecklistDetail
        .where('TaskID')
        .equals(TaskId)
        .filter((row: any) =>
          row.templateId === templateId && row.controlName === controlName
        )
        .toArray();
      if (records.length === 0) {
        return { Status: false, data: 'No matching record found' };
      }

      // Update each matching record
      const updates = records.map(async (record) => {
        return db.ChecklistDetail.update(record.CheckListId, {
          isEnable: isEnable,
          controlvalue: controlvalue ?? record.controlvalue
        });
      });

      await Promise.all(updates);

      return { Status: true, data: records.length + ' record(s) updated' };
    } catch (error) {
      console.error('Dexie update failed:', error);
      return { Status: false, data: error };
    }
  }


  async deleteChecklistFromLocalDbByControlName(
    TaskId: any,
    controlName: any,
    templateId: any
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    try {
      // Find matching records first
      const records = await db.ChecklistDetail
        .where('TaskID')
        .equals(TaskId)
        .filter((row: any) =>
          row.templateId === templateId && row.controlName === controlName
        )
        .toArray();

      if (records.length === 0) {
        return { Status: false, data: 'No matching record found' };
      }

      // Delete each matching record
      const deletions = records.map(async (record) => {
        return db.ChecklistDetail.delete(record.CheckListId);
      });

      await Promise.all(deletions);

      return { Status: true, data: records.length + ' record(s) deleted' };
    } catch (error) {
      console.error('Dexie delete failed:', error);
      return { Status: false, data: error };
    }
  }

  async updateChecklistTableControl(
    TaskId: any,
    controlName: any,
    controlvalue: any,
    templateId: any
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();

    try {
      const controlValue = Array.isArray(controlvalue)
        ? JSON.stringify(controlvalue)
        : controlvalue;

      // Find the matching record(s)
      const records = await db.ChecklistDetail
        .where('TaskID')
        .equals(TaskId)
        .filter((record: any) =>
          record.templateId === templateId && record.controlName === controlName
        )
        .toArray();

      if (records.length === 0) {
        return { Status: false, data: 'No matching record found' };
      }

      // Update each matched record
      const updates = records.map(record =>
        db.ChecklistDetail.update(record.CheckListId, {
          controlvalue: controlValue,
          isUploadedOnServer: 'false'
        })
      );

      await Promise.all(updates);

      return { Status: true, data: `${records.length} record(s) updated` };
    } catch (error) {
      console.error('Dexie updateChecklistTableControl failed:', error);
      return { Status: false, data: error };
    }
  }

  // idb-service.ts
  // In app-services or a dedicated service
  async addTaskTemplateDataInBulk(objects: any): Promise<void> {
    console.log("---------901");
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }

    try {
      await this.db.TaskTemplateDetails.bulkPut(objects); // insert or update
    } catch (error) {
      console.error('Bulk insert failed:', error);
      throw error;
    }
  }




  async updateTemplateQuesBulk(
    updates: { taskId: string; templateId: string; templateQues: any; templateQuesValue: any }[]
  ): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();
    console.log("---------921");
    try {
      if (!updates || updates.length === 0) {
        return { Status: false, data: 'No updates provided' };
      }

      // Collect update promises
      const updatePromises = updates.map(async (u) => {
        // Find record by taskId + templateId
        const record = await db.TaskTemplateDetails
          .where('taskId')
          .equals(u.taskId)
          .filter((row: any) => row.templateId === u.templateId)
          .first();

        if (!record) {
          console.warn(`No record found for taskId=${u.taskId}, templateId=${u.templateId}`);
          return null;
        }

        // Perform update
        return db.TaskTemplateDetails.update(record.TaskTempId, {
          // templateQues: this.safeStringify(u.templateQues),
          templateQuesValue: this.safeStringify(u.templateQuesValue),
        });
      });
      const results = await Promise.all(updatePromises);
      const updatedCount = results.filter((r) => r !== null).length;
      return { Status: true, data: `${updatedCount} record(s) updated` };
    } catch (error) {
      console.error('Bulk templateQues update failed:', error);
      return { Status: false, data: error };
    }
  }

  safeStringify(obj: any) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return '[Circular]'; // replace circular refs
        }
        seen.add(value);
      }
      return value;
    });
  }




  async deleteDynamicCardTaskTemplateService(TaskId: any): Promise<{ Status: boolean; data?: any }> {
    const db = new DigitalEyesDb();
    console.log("---------976");
    try {
      // Get all primary keys matching the TaskId
      const keysToDelete = await db.TaskTemplateDetails
        .where('taskId')
        .equals(TaskId)
        .primaryKeys();

      // Bulk delete them
      await db.TaskTemplateDetails.bulkDelete(keysToDelete);

      return { Status: true, data: `${keysToDelete.length} record(s) deleted` };
    } catch (error) {
      console.error('Dexie deleteDynamicCardTaskTemplateService failed:', error);
      return { Status: false, data: JSON.stringify(error) };
    }
  }

  async getDynamicCardTaskTemplateFromIdb(taskId: any): Promise<any[]> {
    const db = new DigitalEyesDb();
    let items: any[] = [];
    console.log("---------997");
    try {
      const result = await db.TaskTemplateDetails.where('taskId').equals(taskId).toArray();
      for (const row of result) {
        items.push({
          TaskTempId: row.TaskTempId,
          createdAt: row.createdAt,
          noCatImageReason: row.noCatImageReason,
          status: row.status,
          taskId: row.taskId,
          templateId: row.templateId,
          templateJson: JSON.parse(row.templateJson || '{}'),
          templateJsonValue: JSON.parse(row.templateJsonValue || '{}'),
          templateName: this.encryptionService.decrypt(row.templateName),
          templateQues: JSON.parse(row.templateQues || '[]'),
          version: row.version,
          zoneKeys: JSON.parse(row.zoneKeys || '[]'),
          segmentOrder: JSON.parse(row.segmentOrder)
        });
      }
      return items;
    } catch (error) {
      console.error('Error reading TaskTemplateDetails from IndexedDB:', error);
      return [];
    }
  }


  async getTemplateDetailFromIdb(taskId: any, templateId: any): Promise<any[]> {
    const db = new DigitalEyesDb();
    let items: any[] = [];
    console.log("---------1028");
    try {
      const result = await db.TaskTemplateDetails
        .where('taskId')
        .equals(taskId)
        .filter(row => row.templateId === templateId)
        .toArray();
      for (const row of result) {
        items.push({
          TaskTempId: row.TaskTempId,
          createdAt: row.createdAt,
          noCatImageReason: row.noCatImageReason,
          status: row.status,
          taskId: row.taskId,
          templateId: row.templateId,
          templateJson: JSON.parse(row.templateJson || '{}'),
          templateJsonValue: JSON.parse(row.templateJsonValue || '{}'),
          templateName: this.encryptionService.decrypt(row.templateName),
          templateQues: JSON.parse(row.templateQues || '[]'),
          version: row.version,
          zoneKeys: JSON.parse(row.zoneKeys || '[]')
        });
      }
      return items;
    } catch (error) {
      console.error('Error reading TaskTemplateDetails from IndexedDB:', error);
      return [];
    }
  }


  async updateTemplateAfterControlAdd(taskId: string, templateId: string, templateJson: string): Promise<{ Status: boolean; data: any }> {
    const db = new DigitalEyesDb();
    console.log("---------1061");
    try {
      await this.db.TaskTemplateDetails
        .where('taskId')
        .equals(taskId)
        .filter(item => item.templateId === templateId)
        .modify({ templateJson: JSON.stringify(templateJson) });
    } catch (err) {
      console.error('Dexie error:', err);
      return { Status: false, data: err };
    }
  }

  async updateTemplateAfterQuesAdd(taskId: string, templateId: string, templateQues: string): Promise<{ Status: boolean; data: any }> {
    const db = new DigitalEyesDb();
    console.log("---------1071");
    try {
      await this.db.TaskTemplateDetails
        .where('taskId')
        .equals(taskId)
        .filter(item => item.templateId === templateId)
        .modify({ templateQues: JSON.stringify(templateQues) });
    } catch (err) {
      console.error('Dexie error:', err);
      return { Status: false, data: err };
    }
  }

  async getMetaDataDetailToUpload(taskID: string, OrgId, FileName: string | null = null): Promise<any[]> {
    const db = new DigitalEyesDb();
    const items: any[] = [];

    try {
      const results = await db.MetaFileDetails
        .where('TaskID')
        .equals(taskID)
        .and(item => item.orgid == OrgId && item.status === 'Active')
        .toArray();

      for (const item of results) {
        let displayUrl = '';

        if (item.localFileBuffer && item.localFileBuffer.byteLength > 0) {
          // wrap in Blob (browser manages this memory)
          const blob = new Blob([item.localFileBuffer], {
            type: item.localFileMime || 'image/jpeg'
          });

          //create tiny URL pointer
          displayUrl = URL.createObjectURL(blob);

          //  CRITICAL: null the buffer reference immediately
          // blob already has the data, buffer is no longer needed in JS heap
          item.localFileBuffer = null;
        }

        items.push({
          MetaFileId: item.MetaFileId,
          TaskID: item.TaskID,
          controlId: item.controlId,
          FileType: item.fileType,
          localFileUrl: displayUrl,
          localFileBuffer: null,
          localFileMime: item.localFileMime,
          FileName: this.encryptionService.decrypt(item.FileName),
          MetaData: item.metaData,
          observationText: this.encryptionService.decrypt(item.observationText),
          serverFileName: this.encryptionService.decrypt(item.serverFileName),
          ServerFileUrl: item.serverFileUrl,
          status: item.status,
          zoneName: item.zoneName,
          photoCategory: JSON.parse(item.photoCategory || '[]'),
          orginalFileName: this.encryptionService.decrypt(item.originalFileName),
          AICheck: item.AICheck,
          AIObservation: item.AIObservation,
          orgid: item.orgid
        });
      }

      return items;

    } catch (error) {
      console.error('Dexie getMetaDataDetailToUpload failed:', error);
      return [];
    }
  }

  async getDynamicCardImageFromIdb(TaskId: string, OrgId: any, FileName: string | null = null): Promise<{ status: boolean; data: any[] }> {
    const db = new DigitalEyesDb();
    const items: any[] = [];

    try {
      let results: any[];
      if (FileName) {
        const encryptedFileName = this.encryptionService.encrypt(FileName);
        results = await db.InspectionFilesDetails
          .where('taskId')
          .equals(TaskId)
          .and(item => item.orgid == OrgId && item.fileName === encryptedFileName)
          // .filter(item => item.fileName === encryptedFileName)
          .toArray();
      } else {
        results = await db.InspectionFilesDetails
          .where('taskId')
          .equals(TaskId)
          .and(item => item.orgid == OrgId)
          .toArray();
      }
      for (const item of results) {
        items.push({
          InspectionFileId: item.InspectionFileId,
          ImgFileIdForAudio: item.ImgFileIdForAudio,
          taskId: item.taskId,
          UserID: item.UserID,
          zoneDetails: item.zoneDetails,
          fileType: item.fileType,
          // LocalFileUrl: item.LocalFileUrl,
          LocalFileBuffer: null,
          LocalFileUrl: null,
          createdAt: item.createdAt,
          FileSize: item.fileSize,
          fileName: item.fileName,
          UploadStatus: item.UploadStatus,
          fileCustomName: this.encryptionService.decrypt(item.serverFileName),
          metadata: item.metadata,
          controlName: item.controlName,
          zone: item.zone,
          photoCategory: item.photoCategory,
          originalFileName: item.originalFileName,
          metaTags: item.metaTags,
          ObservationText: item.ObservationText,
          orgid: item.orgid,
          liveUrl: item.liveUrl

        });
      }

      return { status: items.length > 0, data: items };
    } catch (err) {
      console.error('Dexie getDynamicCardImageFromIdb error:', err);
      return { status: false, data: [] };
    }
  }

  async getChecklistFromIdb(taskId: string): Promise<{ status: boolean; data: any[] }> {
    const db = new DigitalEyesDb();
    const items: any[] = [];

    try {
      const results = await db.ChecklistDetail
        .where('TaskID')
        .equals(taskId)
        .filter(item => item.controlType !== 'table' && item.controlType !== 'checkbox')
        .toArray();

      for (const item of results) {
        items.push({
          CheckListId: item.CheckListId,
          TaskID: item.TaskID,
          controlName: item.controlName,
          controlType: item.controlType,
          controlvalue: item.controlvalue,
          templateName: item.templateName,
          templateId: item.templateId,
          isUploadedOnServer: item.isUploadedOnServer,
        });
      }

      return { status: items.length > 0, data: items };
    } catch (err) {
      console.error('Dexie getChecklistFromIdb error:', err);
      return { status: false, data: [] };
    }
  }

  async getChecklistTablecontrolFromIdb(taskId: string): Promise<{ status: boolean; data: any[] }> {
    const db = new DigitalEyesDb();
    const items: any[] = [];

    try {
      const results = await db.ChecklistDetail
        .where('TaskID')
        .equals(taskId)
        .filter(item => item.controlType === 'table' || item.controlType === 'checkbox')
        .toArray();

      for (const item of results) {
        items.push({
          CheckListId: item.CheckListId,
          TaskID: item.TaskID,
          controlName: item.controlName,
          controlType: item.controlType,
          controlvalue: JSON.parse(item.controlvalue),
          templateName: item.templateName,
          templateId: item.templateId,
          isUploadedOnServer: item.isUploadedOnServer,
        });
      }

      return { status: items.length > 0, data: items };
    } catch (err) {
      console.error('Dexie getChecklistTablecontrolFromIdb error:', err);
      return { status: false, data: [] };
    }
  }


  async saveFnolTemplateData(taskId: string, data: any): Promise<void> {
    const db = new DigitalEyesDb();
    try {
      await db.fnolDataTable.where('taskId').equals(taskId).delete();
      await this.db.fnolDataTable.add({ taskId, data });
    } catch (error) {
      console.error('Error saving task detail:', error);
    }
  }

  async getTaskDetail(taskId: string) {
    const db = new DigitalEyesDb();
    return await db.fnolDataTable.where('taskId').equals(taskId).first();
  }

  // Migration Script
  async runMigrationIfNeeded(): Promise<void> {
    const db = new DigitalEyesDb();

    try {
      // read what format was last used
      const setting = await db.AppSettings.get('storageFormat');
      const storedFormat = setting?.value ?? null;

      console.log(`Migrationstored format: ${storedFormat} | code format: ${CURRENT_STORAGE_FORMAT}`);

      if (!storedFormat) {
        // first run — just set the flag, no migration needed
        await db.AppSettings.put({ key: 'storageFormat', value: CURRENT_STORAGE_FORMAT });
        return;
      }

      if (storedFormat === CURRENT_STORAGE_FORMAT) {
        return;
      }

      // formats differ — run migration
      if (storedFormat === 'arraybuffer' && CURRENT_STORAGE_FORMAT === 'base64') {
        await this.migrateArrayBufferToBase64(db);
      } else if (storedFormat === 'base64' && CURRENT_STORAGE_FORMAT === 'arraybuffer') {
        await this.migrateBase64ToArrayBuffer(db);
      }
      // update flag after successful migration
      await db.AppSettings.put({ key: 'storageFormat', value: CURRENT_STORAGE_FORMAT });
    } catch (err: any) {
      console.error('Migration failed:', err?.message);
    }
  }

  // ── ArrayBuffer → base64 (rollback scenario) ────────────────────────────
  private async migrateArrayBufferToBase64(db: DigitalEyesDb): Promise<void> {
    const files = await db.InspectionFilesDetails.toArray();
    for (const record of files) {
      try {
        if (!record.LocalFileBuffer) continue;
        const buffer = record.LocalFileBuffer instanceof Uint8Array
          ? record.LocalFileBuffer.buffer.slice(
            record.LocalFileBuffer.byteOffset,
            record.LocalFileBuffer.byteOffset + record.LocalFileBuffer.byteLength
          )
          : record.LocalFileBuffer;
        const base64 = this.arrayBufferToBase64(buffer, record.LocalFileMime || 'image/jpeg');
        await db.InspectionFilesDetails.update(record.InspectionFileId, {
          LocalFileUrl: base64,
          LocalFileBuffer: null,
          LocalFileMime: null
        });
      } catch (err: any) {
        console.error(`[Migration] Failed to convert file: ${record.fileName}`, err?.message);
      }
    }

    // same for MetaFileDetails
    const metas = await db.MetaFileDetails.toArray();
    for (const record of metas) {
      try {
        if (!record.localFileBuffer) continue;

        const buffer = record.localFileBuffer instanceof Uint8Array
          ? record.localFileBuffer.buffer.slice(
            record.localFileBuffer.byteOffset,
            record.localFileBuffer.byteOffset + record.localFileBuffer.byteLength
          )
          : record.localFileBuffer;

        const base64 = this.arrayBufferToBase64(buffer, record.localFileMime || 'image/jpeg');

        await db.MetaFileDetails.update(record.MetaFileId, {
          localFileUrl: base64,
          localFileBuffer: null,
          localFileMime: null
        });

      } catch (err: any) {
        console.error(`MigrationFailed to convert meta: ${record.FileName}`, err?.message);
      }
    }
  }

  // ── base64 → ArrayBuffer 
  private async migrateBase64ToArrayBuffer(db: DigitalEyesDb): Promise<void> {
    const files = await db.InspectionFilesDetails.toArray();
    for (const record of files) {
      try {
        if (!record.LocalFileUrl) continue;

        const { buffer, mimeType } = this.base64ToArrayBuffer(record.LocalFileUrl);

        await db.InspectionFilesDetails.update(record.InspectionFileId, {
          LocalFileBuffer: new Uint8Array(buffer),
          LocalFileMime: mimeType,
          LocalFileUrl: ''         // clear old field
        });
      } catch (err: any) {
        console.error(`Migration Failed to convert file: ${record.fileName}`, err?.message);
      }
    }

    const metas = await db.MetaFileDetails.toArray();
    for (const record of metas) {
      try {
        if (!record.localFileUrl) continue;

        const { buffer, mimeType } = this.base64ToArrayBuffer(record.localFileUrl);

        await db.MetaFileDetails.update(record.MetaFileId, {
          localFileBuffer: new Uint8Array(buffer),
          localFileMime: mimeType,
          localFileUrl: ''
        });

      } catch (err: any) {
        console.error(`[Migration] Failed to convert meta: ${record.FileName}`, err?.message);
      }
    }
  }

  // ── conversion

  private arrayBufferToBase64(buffer: ArrayBuffer, mimeType: string): string {
    const uint8 = new Uint8Array(buffer);
    let binary = '';
    // process in chunks to avoid call stack overflow on large files
    const chunkSize = 8192;
    for (let i = 0; i < uint8.length; i += chunkSize) {
      binary += String.fromCharCode(...uint8.subarray(i, i + chunkSize));
    }
    return `data:${mimeType};base64,${btoa(binary)}`;
  }

  private base64ToArrayBuffer(base64: string): { buffer: ArrayBuffer; mimeType: string } {
    const [header, data] = base64.includes(',')
      ? base64.split(',')
      : ['data:image/jpeg;base64', base64];

    const mimeType = header.match(/data:([^;]+)/)?.[1] || 'image/jpeg';
    const binary = atob(data);
    const buffer = new ArrayBuffer(binary.length);
    const uint8 = new Uint8Array(buffer);
    for (let i = 0; i < binary.length; i++) {
      uint8[i] = binary.charCodeAt(i);
    }
    return { buffer, mimeType };
  }


  async addOrgMasterDataBulk(taskId: string, orgId: string, rawData: object): Promise<void> {
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }
    try {
      // Check if record exists against taskId & orgId
      const existing = await this.db.orgMasterDataTable
        .where({ taskId, orgId })
        .first();
      // If exists, delete it first
      if (existing) {
        await this.db.orgMasterDataTable
          .where({ taskId, orgId })
          .delete();
      }
      // Insert fresh record
      const record = {
        taskId,
        orgId,
        data: JSON.stringify(rawData),
      };
      await this.db.orgMasterDataTable.bulkPut([record]);
    } catch (error) {
      console.error('Insert/Update failed:', error);
      throw error;
    }
  }
  async getOrgMasterData(taskId: string, orgId: string): Promise<any> {
    console.log("taskId", taskId)
    console.log('orgId', orgId)
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }

    try {
      const existing = await this.db.orgMasterDataTable.where("taskId").equals(taskId).toArray();
      // const existing = await this.db.orgMasterDataTable
      //   .where({ taskId })
      //   .first();
      console.log("existing", existing)
      if (existing) {
        return JSON.parse(existing[0].data);
      }

      return null;

    } catch (error) {
      console.error('Fetch failed:', error);
      throw error;
    }
  }


  async getTaskFileDetailsToUpload(taskId, maxHitCounter, orgId) {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionFilesDetails
      .where("taskId").equals(taskId)
      .and(item => item.RetryHitting < maxHitCounter && item.UploadStatus == 'false' && item.orgid == orgId)
      .toArray();
  }

  async getTaskFileDetailsToUploading(taskId, maxHitCounter, orgId) {
    this.db = new DigitalEyesDb();
    return await this.db.InspectionFilesDetails
      .where("taskId").equals(taskId)
      .and(item => item.RetryHitting < maxHitCounter && item.UploadStatus == 'syncing' && item.orgid == orgId)
      .toArray();
  }

  // NEW: reactive stream of everything not-yet-uploaded (pending + failed)
  watchTaskFileDetailsToUpload(taskId: string, orgId: string) {
    this.db = new DigitalEyesDb();
    return liveQuery(() =>
      this.db.InspectionFilesDetails
        .where("taskId").equals(taskId)
        .and(item => item.orgid == orgId)
        .toArray()
    );
  }

  // NEW: reset retry counter so background upload service picks it up again
  async retryFailedFiles(taskId: string, orgId: string, maxHitCounter: number) {
    this.db = new DigitalEyesDb();
    const failed = await this.db.InspectionFilesDetails
      .where("taskId").equals(taskId)
      .and(item => item.orgid == orgId && item.UploadStatus == 'false' && item.RetryHitting >= maxHitCounter)
      .toArray();

    for (const f of failed) {
      await this.db.InspectionFilesDetails.update(f.id, { RetryHitting: 0 });
    }
  }

  async addAddressHistoryRecord(record: any): Promise<void> {
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }
    try {
      // Check if record exists against id (server's own record id)
      const existing = await this.db.AddressHistoryDetails
        .where({ id: record.id })
        .first();
      // If exists, delete it first
      if (existing) {
        await this.db.AddressHistoryDetails
          .where({ id: record.id })
          .delete();
      }

      // Insert fresh record — carry forward downloadStatus/imageArrayBuffer from the
      // existing row if present, so metadata refreshes never wipe out an already-downloaded image
      const mergedRecord = {
        ...record,
        downloadStatus: record.downloadStatus ?? existing?.downloadStatus ?? 'pending',
        imageArrayBuffer: record.imageArrayBuffer ?? existing?.imageArrayBuffer,
      };

      await this.db.AddressHistoryDetails.bulkPut([mergedRecord]);

    } catch (error) {
      console.error('Insert/Update failed:', error);
      throw error;
    }
  }

  async getAddressHistoryRecord(id: number): Promise<any> {
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }
    return this.db.AddressHistoryDetails.where({ id }).first();
  }
  async getAddressHistoryByTaskId(taskId: string): Promise<any[]> {
    if (!this.db) {
      this.db = new DigitalEyesDb();
    }
    return this.db.AddressHistoryDetails
      .where({ taskId })
      .toArray();
  }
}




